@if (accountingPlan && productPlan) {
  <panel style="min-width: 800px">
    <h1>{{'ledger-posts.save.title' | translate: {'oldTcv' : (accountingPlan.totalPlanValue | currency), 'newTcv': (newTcv| currency), 'tcvDifference': (tcvDifference | currency)} }}</h1>
    @if (isMismatchOfAcvAndAnnualRenewalValue) {
      <list-view>
        <list-item warning statusIcon="exclamation-triangle">{{ 'ledger-posts.save.current-annual-contract-value' | translate: {'ACV' : (annualContractValue | currency), 'annualValueForRenewal': (productPlan.annualValueForRenewal | currency)} }}</list-item>
      </list-view>
    }
    <section>
      <button ghost (click)="cancel()">{{'general.cancel' | translate}}</button>
      <button confirm (click)="save()">{{ (isMismatchOfAcvAndAnnualRenewalValue ? 'ledger-posts.save-without-updating-renewal' : 'ledger-posts.save') | translate }}</button>
      @if (isMismatchOfAcvAndAnnualRenewalValue) {
        <button confirm (click)="updateAndSave()">{{ 'ledger-posts.save-and-update-renewal' | translate }}</button>
      }
    </section>
  </panel>
}
